export const MenuLogo = () => {
	return (
			<div className="flex items-center flex-shrink-0 px-4 border-b border-gray-200">
				<img className="mb-5 h-8 w-auto" src="logo.png" alt="Workflow" />
			</div>
	);
};
